// import { useRedirectHelpers } from '@/composables/useRedirectHelpers'

/**
 * Desktop Redirect Plugin
 *
 * Automatically redirects desktop users from the mobile designer app to the main storefront.
 * Uses screen dimensions to detect desktop users and calls Magento API to get proper product URLs.
 */

// interface MagentoProductResponse {
//     name: string
//     sku: string
//     custom_attributes?: Array<{
//         attribute_code: string
//         value: string
//     }>
// }

export default defineNuxtPlugin(async () => {
    // Just return early since this epic is setting up desktop
    // return

    const { getRedirectUrlForSku } = useRedirectHelpers()

    // Detect desktop users using screen dimensions
    const screenWidth = window.innerWidth
    const screenHeight = window.innerHeight
    const isMobile = screenWidth < 768 || (screenWidth < 1024 && screenHeight < 768)

    // Check if route has SKU parameter
    const route = useRoute()
    if (!isMobile && route.path.startsWith('/designer/')) {
        const sku = route.params.sku?.toString() || null
        const redirectUrl = await getRedirectUrlForSku(sku)
        await navigateTo(redirectUrl, { external: true })
    }

    // // Detect desktop users using screen dimensions
    // const screenWidth = window.innerWidth
    // const screenHeight = window.innerHeight
    // const isMobile = screenWidth < 768 || (screenWidth < 1024 && screenHeight < 768)

    // // Check if route has SKU parameter
    // const route = useRoute()
    // if (!isMobile && route.path.startsWith('/designer/')) {
    //     const storefrontUrl =
    //         config.public?.storefrontUrl || 'https://dev-storefront.app-crane.com'

    //     let redirectUrl = storefrontUrl

    //     if (route.params.sku) {
    //         const magentoApiUrl = config.public?.magentoApiUrl

    //         if (magentoApiUrl) {
    //             // Call Magento API to get product url_key
    //             const response = (await $fetch(
    //                 `${magentoApiUrl}/rest/V1/products/${encodeURIComponent(route.params.sku.toString())}`
    //             )) as MagentoProductResponse

    //             // Extract url_key from custom_attributes
    //             let urlKey = null
    //             if (response?.custom_attributes) {
    //                 const urlKeyAttr = response.custom_attributes.find(
    //                     (attr) => attr.attribute_code === 'url_key'
    //                 )
    //                 if (urlKeyAttr) {
    //                     urlKey = urlKeyAttr.value
    //                 }
    //             }

    //             // Use url_key if valid, otherwise fallback to homepage
    //             if (urlKey && urlKey.trim()) {
    //                 redirectUrl = `${storefrontUrl}/${urlKey}`
    //             }
    //         }
    //     }

    //     await navigateTo(redirectUrl, { external: true })
    // }
})
